import { IconDefinition } from '@fortawesome/fontawesome-common-types';

const formatViewbox = (icon: IconDefinition ) => {
  switch(`${icon.prefix}-${icon.iconName}`) {
    case('fal-sort-up'):
      return `0 -128 ${icon.icon[0]} ${icon.icon[1]}`;
    case('fal-sort-down'):
      return `0 128 ${icon.icon[0]} ${icon.icon[1]}`;
  }

  return `0 0 ${icon.icon[0]} ${icon.icon[1]}`;
}

const convertFontAwesomeIcon = (icon : IconDefinition) => {
  return {
    name: icon.iconName,
    viewBox: formatViewbox(icon),
    content: `<path d="${icon.icon[4]}" />`,
  };
}

export default convertFontAwesomeIcon;
